var map = {
	"./application-statuses.png": 458,
	"./application-types.png": 984,
	"./areas.png": 4398,
	"./audit-log.png": 4738,
	"./authorities-issuing.png": 7240,
	"./basis-expenditure.png": 7716,
	"./branches.png": 6455,
	"./brands.png": 9137,
	"./cars.png": 3162,
	"./customers.png": 532,
	"./double-caret-left.png": 8299,
	"./employees.png": 6897,
	"./gold.png": 4130,
	"./goods.png": 5399,
	"./group.png": 7350,
	"./guarantee-period.png": 5312,
	"./home.png": 1825,
	"./logout.png": 6422,
	"./m_audit-log.png": 5137,
	"./m_customers.png": 6746,
	"./m_employees.png": 5323,
	"./m_gold.png": 4082,
	"./m_goods.png": 1445,
	"./m_group.png": 7722,
	"./m_qr.png": 783,
	"./m_reference.png": 919,
	"./m_regdoc.png": 3017,
	"./m_sales-plans.png": 8564,
	"./m_service.png": 2443,
	"./m_stock.png": 9966,
	"./manbook.png": 7725,
	"./manufacturer-country.png": 8536,
	"./payment-methods.png": 124,
	"./payment-state.png": 9698,
	"./qr.png": 2669,
	"./reference.png": 6959,
	"./regdoc.png": 9811,
	"./return-type.png": 2958,
	"./right.png": 1569,
	"./roles.png": 1042,
	"./sales-plans.png": 3598,
	"./service-statuses.png": 4080,
	"./service.png": 6015,
	"./stock.png": 7088,
	"./types-discounts.png": 1689,
	"./types-identity-documents.png": 6061,
	"./types-services.png": 3186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6023;